/**
 * Header Component
 * Redux connected
 * 
 * Can show or not show the title bar, driven by props.title
 * 
 * @prop {String} title
 */

import React from 'react';

import { connect } from "react-redux";

import useNavPath from '../hooks/useNavPath';

import HeaderTitle from './HeaderTitle';

import { isHomePage } from '../helpers/browser-navigation-helper';

import './Header.css';

import logo from '../images/logo/logo.png';

const mapStateToProps = state => {
    return {
        title: state.gui.currentStepTitle,
        quotationsMethod: state.quotationsMethod
    };
};

const Header = (props) => {

    const [navPath, setNavPath, navigateToNavPath] = useNavPath();

    const onClickLogo = (evt) => {
        //navigateToSunhubWebsite();
        if (!isHomePage()) {
            setNavPath('/');
        }
    };

    return (navPath !== null) ?
        navigateToNavPath() :
        (
            <div className='slc-header'>
                <div className='slc-header-logo'>
                    <img className="slc-header-logo__image" src={ logo } alt="Sunhub" onClick={ onClickLogo } />
                </div>
                <HeaderTitle
                    title={ props.title }
                    quotationsMethod={ props.quotationsMethod } />
            </div>
        );

}

// Export unwrapped component in order to test it in isolation from Redux
export {
    Header
};

// Export Redux connected component as default
export default connect(mapStateToProps)(Header);